import React from 'react';

import { withLocales } from '@spotahome/bff/client';

import { SeoRoutingConsumer } from '../context/SeoRoutingContext';

const getAvailableLocales = (locales, routing) =>
  Object.keys(locales).filter(locale => routing[locale]);

const withAvailableLocales = () => Comp =>
  withLocales()(({ locales, ...restProps }) => (
    <SeoRoutingConsumer>
      {routing => (
        <Comp
          {...restProps}
          locales={locales}
          routing={routing}
          availableLocales={getAvailableLocales(locales.ui, routing)}
        />
      )}
    </SeoRoutingConsumer>
  ));

export default withAvailableLocales;
